import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash"

import Spin from '../../../commonModules/interface/Spin';
import { CardLayout, BreadCrumb } from './containers/Layout';
import ListAvoir from './transfers/avoirs/ListTransferAvoir.jsx';
// import Form from './avoirs/Form.jsx';
import SingleShop from './shops/SingleShop';
import { Button, Card, Grid, Box, IconButton } from '@material-ui/core';
import CardPage from '../../../commonModules/layouts/CardPage';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import { firstDayOfYear, sixMonthsAgo } from '../../../commonModules/utils/statsFunctions';
import DateFilter, { filterDate } from './Filter/DateFilter';
import ShopFilter, { filterShop } from './Filter/ShopFilter';
import AccordionFilter from './Filter/AccordionFilter';
import SingleTransferAvoir from './transfers/avoirs/SingleTransferAvoir';

class Avoirs extends Component{
    state = {
        view: this.props.new ? "new" : "list",
        listview: "avoir",

        singleShop:{},
        singleAvoir:{
            avoir:{},
            shop:{},
            client:{},
            agent:{},
        },

        breadcrumb: "",
        currentPage: 0,
        currentPageProd: 0,
        rowsPerPage: 20,

        selectShop: {label:"", value:""},
        searchType: "",
        searchClient: "",
        searchFacture: "",
        searchCredit: "", 
        searchProduct: "", 
		// start_date: firstDayOfYear,
		start_date: sixMonthsAgo,
        end_date: new Date(),
    }
        
    componentDidMount = () => {
        if(isEmpty(this.props.AGENTS)){
            this.props.fetchAgents()
        }
    }
    // select options 
        createShopList = () => {
            const list = [{value:"", label:"Tous les Magasins"}]
            const { SHOPS } = this.props
            if( !isEmpty(SHOPS) ){
                Object.values(SHOPS).forEach( shop => { 
                    list.push (       
                        {value:shop.id, label:shop.name} 
                    )
                })
            } 
            return list
        }
        createClientList = () => {
            const list = [{value:"", label:"Tous les Clients"}]
            const { CLIENTS } = this.props
            if( CLIENTS ){
                Object.values(CLIENTS).map(client => { 
                    list.push (       
                        {value:client.id, label:client.client_lastname} 
                    )
                })
            } 
            return list
        }
        normalizeStr = (str) => {// remove accent and lower case str
            if (str){
                console.log("str exist", {str}, isEmpty(str));
                str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
            }
            return str
        }
        prodFilter = (prodID) => {
            const { PRODUCTS } = this.props;
            const { searchProduct } = this.state
    
            let product = PRODUCTS[prodID]
            let searching = searchProduct ? this.normalizeStr(searchProduct) : ""
    
            const productName = product ? this.normalizeStr(product.name) : ""
            const productRef = product ? this.normalizeStr(product.ref) : ""
            const productType = product ? this.normalizeStr(product.type) : ""
            const productBrand = product ? this.normalizeStr(product.marque) : ""
    
            return ( 
                productName.indexOf(searching) !== -1 ||
                productRef.indexOf(searching) !== -1 ||
                productType.indexOf(searching) !== -1 ||
                productBrand.indexOf(searching) !== -1
            )  
        }

        handleChange = (e) => {
            const { name, value } = e.target;
            this.setState({
                [name]: value,
                currentPage: 0,
                currentPageProd: 0,
            })
        }
        handleSelect = (option, name) => {
            this.setState({
                [name]: option.value, 
                currentPage: 0,
                currentPageProd: 0,
            })
        } 

        handleSelectMulti = (option, name) => {
            if(option){
                this.setState({                
                    [name]: option,
                    currentPage: 0,
                    currentPageProd: 0,
                })
            } else {
                this.setState({
                    [name]: {label: "", value: ""},
                    currentPage: 0,
                    currentPageProd: 0,
                })
    
            }
        }
        getFilteredList = () => {
            const { AVOIRS } = this.props;
            const { selectShop, searchClient, searchFacture, searchType, searchCredit } = this.state;
            
            let list = filterDate(AVOIRS, this.state.start_date, this.state.end_date, "creation_date")
            // status
            if (typeof searchCredit == "boolean"){
                list = list.filter(item => item.avoir_credit == searchCredit)
            }
            // client
            if (!isEmpty(searchClient)) {
                list = list.filter(item => item.client_ref === searchClient || item.avoir_paygo_id === searchClient )
                // list = list.filter(item => this.filterClients(item))
            }
            // type
            if(!isEmpty(searchType)){
                if (searchType === "commercial") {
                    list = list.filter(item => item.shop_id === "Commercial")
                } else {
                    list = list.filter(item => item.nature === searchType)
                }
            }
            // shop
            // if(!isEmpty(selectShop)){
            //     list = list.filter(item => item.shop_id === selectShop)
            // }
            list = filterShop(list, selectShop)
            // if( !isEmpty(selectShop.value)) {
            //     list = list.filter( item => item.shop_id === selectShop.value)
            // }
            // if( Array.isArray(selectShop) && !isEmpty(selectShop) ) {
            //     let itemList = selectShop.map(item => item.value )
            //     list = list.filter( item => itemList.includes(item.shop_id))
            // }
            
            // fact
            if(!isEmpty(searchFacture)){
                const normalizeRef = (s) => (s || '').toString().toLowerCase().replace(/[-/\s_]/g, '');
                const search = normalizeRef(searchFacture);
                list = list.filter(item =>
                    normalizeRef(item.id).indexOf(search) > -1 ||
                    normalizeRef(item.intern_ref_id).indexOf(search) > -1
                );
            }
            return list
        }
        
    // CLEAR & DISPLAY
        handleClose = () => {
            this.setState({
                view:"list",
                breadcrumb: "",
            });
            // this.clearForms()
        }
        handleSingleAvoir = (avoir, shop, client, agent) => {
            this.setState({
                view:"avoir",
                breadcrumb:`${avoir.nature} n°${avoir.id}`,
                singleAvoir:{avoir, shop, client, agent},
            })
        }
        handleSingleShop = (shop) => {
            this.setState({
                breadcrumb: shop.name,
                singleShop:shop,
                view: "shop"
            })
        }
        onChangePage = (pageOfItems, page, rowsPerPage) => {
            this.setState({ currentPage:page, rowsPerPage });
        }
        onChangePageProd = (pageOfItemsProd, page , rowsPerPage) => {
            this.setState({ currentPageProd:page , rowsPerPage});
        }
    render(){
        console.log("[STATE] stock ",this.state);

        let clients = this.createClientList()

        return(
            <CardPage title="Avoirs" storehouse >
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Avoirs" back={this.handleClose} />
                {/* {this.state.view === "new" &&
                    <Form {...this.props} handleClose={ this.handleClose } />
                } */}
                {this.state.view === "avoir" &&
                    <SingleTransferAvoir 
                        avoir={this.state.singleAvoir.avoir} 
                        transfer={this.state.singleAvoir.avoir} 
                        shop={this.state.singleAvoir.shop} 
                        client={this.state.singleAvoir.client} 
                        agent={this.state.singleAvoir.agent} 
                        {...this.props} 
                        getPhoto={this.props.getPhoto} />
                }
                {this.state.view === "shop" &&
                    <SingleShop shop={this.state.singleShop} {...this.props} />
                }
                  
                {this.state.view === "list" &&
                // {this.state.view === "list" && (this.state.listview === "avoir" ||  this.state.listview === "prodList") &&
                <AccordionFilter>
                    <Grid container>
                        {/* <DateFilter
                            handleChangeDate={(date, name) => this.setState({ [name]: date })}
                            {...this.state}
                        /> */}
                        <Grid item xs={12} md={6}>
                            {/* <InputSelect
                                options={shops}
                                value={this.state.selectShop}
                                label="Sélectionner un Magasin"
                                onChange={(option) => this.handleSelect(option, "selectShop") }
                            />  */}
                            <ShopFilter
                                fieldName="selectShop"
                                value={this.state.selectShop}
                                handleSelect={this.handleSelectMulti}
                            />
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={clients}
                                value={this.state.searchClient}
                                label="Client"
                                onChange={(option) => this.handleSelect(option, "searchClient") }
                            /> 
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputText
                                label="Facture"
                                value={this.state.searchFacture}
                                name="searchFacture"
                                onChange={this.handleChange}
                            /> 
                        </Grid>
                    </Grid>
                </AccordionFilter>
                }
                {/* {this.props.STATE.avoirs.fetching && <Spin noOverlay />} */}
               
                {this.state.view === "list" && this.state.listview === "avoir" &&
                <Box>                    
                    {/* {!isEmpty(this.props.AVOIRS) && */}
                        <ListAvoir 
                            {...this.props}
                            {...this.state}
                            onChangePage={this.onChangePage}
                            handleSingleShop={this.handleSingleShop}  
                            handleSingleAvoir={this.handleSingleAvoir}  
                            getFilteredList={this.getFilteredList}  
                            prodFilter={this.prodFilter}  
                        />
                    {/* } */}
                </Box>
                }
                
            </CardPage>
        )
    }
}

export default Avoirs